module.exports = __webpack_public_path__ + "img/img-1.caaf31ad.svg";